import {Checkbox, IconButton, InputAdornment, MenuItem, Paper, TextField, Typography} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {Container} from "@mui/system";
import {isKuhniVersoMebelDomain, kuhniVersoTabletContainerQuerySx} from "../../utils/isKuhniVersoMebelDomain";
import Box from "@mui/material/Box";
import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import Footer from "./Footer";
import React, {useEffect, useRef, useState} from "react";
import {useMediaQuery} from "@mui/material";
import CardByCarousel, {catalogCardFlowSizerSx} from "../../components/UI/carousel/CardByCarousel";
import FormControlLabel from "@mui/material/FormControlLabel";
import {useLocation, useNavigate} from "react-router-dom";
import {constantsErrorMessages} from "../../Constants";
import ModalAlert from "../../components/UI/table/customer-detales/ModalAlert";
import CustomerCompositionController from "../../API/customer/CustomerCompositionController";
import ButtonSelectAction from "../../components/UI/button/ButtonSelectAction";
import catalogFilterToggleIcon from "../../components/Icons/catalogFilterToggle.png";
import {catalogShowMoreButtonWrapperSx} from "./catalogCardGridStyles";

const CATALOG_CARD_GAP = 20;
const CATALOG_COMPACT_CARD_GAP = 12;
const CATALOG_COMPACT_BREAKPOINT = 1440;
const CATALOG_LAYOUT_BREAKPOINT = 1220;
const CATALOG_FILTER_TOGGLE_BREAKPOINT = 1023;
const CATALOG_STACK_BREAKPOINT = 599;
const catalogCompactMq = `@media (max-width: ${CATALOG_COMPACT_BREAKPOINT}px)`;
const catalogFilterToggleMq = `@media (max-width: ${CATALOG_FILTER_TOGGLE_BREAKPOINT}px)`;
const catalogStackMq = `@media (max-width: ${CATALOG_STACK_BREAKPOINT}px)`;
const CATALOG_COMPACT_INPUT_HEIGHT = 36;
const CATALOG_COMPACT_CHECKBOX_SIZE = 20;
const CATALOG_COMPACT_ICON_SIZE = 20;
const catalogCheckboxIconSx = {
    width: 24,
    height: 24,
    borderRadius: "6px",
    border: "1px solid rgba(180, 184, 204, 0.36)",
    boxSizing: "border-box",
    [catalogCompactMq]: {
        width: CATALOG_COMPACT_CHECKBOX_SIZE,
        height: CATALOG_COMPACT_CHECKBOX_SIZE,
        borderRadius: "5px",
    },
};

const catalogCheckboxSx = {
    width: 24,
    height: 24,
    padding: 0,
    [catalogCompactMq]: {
        width: CATALOG_COMPACT_CHECKBOX_SIZE,
        height: CATALOG_COMPACT_CHECKBOX_SIZE,
    },
    "&:hover": {
        backgroundColor: "transparent",
    },
    "&:hover:not(.Mui-checked) .catalog-checkbox-icon": {
        bgcolor: "rgba(180, 184, 204, 0.18)",
    },
};

const catalogFilterIconSx = {
    color: "#737478",
    fontSize: 24,
    width: 24,
    height: 24,
    [catalogCompactMq]: {
        fontSize: CATALOG_COMPACT_ICON_SIZE,
        width: CATALOG_COMPACT_ICON_SIZE,
        height: CATALOG_COMPACT_ICON_SIZE,
    },
};

const catalogFilterIconButtonSx = {
    width: 24,
    height: 24,
    padding: 0,
    [catalogCompactMq]: {
        width: CATALOG_COMPACT_ICON_SIZE,
        height: CATALOG_COMPACT_ICON_SIZE,
    },
};

const catalogTextSx = {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.4,
    color: "#2C3038",
};

const CATALOG_FILTER_WIDTH = "25%";
const CATALOG_CARDS_WIDTH = "75%";
const CATALOG_CARD_WIDTH = `calc(33.333% - ${CATALOG_CARD_GAP}px)`;
const CATALOG_FILTER_WIDTH_WIDE = "33%";
const CATALOG_CARDS_WIDTH_WIDE = "67%";
const CATALOG_CARD_WIDTH_WIDE = `calc(50% - ${CATALOG_CARD_GAP}px)`;
const CATALOG_CARD_WIDTH_1023 = "calc(50% - 10px)";
const CATALOG_CARD_WIDTH_COMPACT = `calc(33.333% - ${CATALOG_COMPACT_CARD_GAP}px)`;
const CATALOG_CARD_WIDTH_WIDE_COMPACT = `calc(50% - ${CATALOG_COMPACT_CARD_GAP}px)`;

const catalogLayoutNarrowMq = `@media (max-width: ${CATALOG_LAYOUT_BREAKPOINT - 1}px)`;

const catalogCardsGridSx = {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    gap: `${CATALOG_CARD_GAP}px`,
    flexWrap: "wrap",
    [catalogCompactMq]: {
        gap: `${CATALOG_COMPACT_CARD_GAP}px`,
    },
    [catalogFilterToggleMq]: {
        gap: `${CATALOG_CARD_GAP}px`,
    },
    [catalogStackMq]: {
        gap: "16px",
    },
};

const catalogCardsSectionSx = {
    boxSizing: "border-box",
    flex: `0 0 ${CATALOG_CARDS_WIDTH}`,
    width: CATALOG_CARDS_WIDTH,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "40px",
    borderRight: (theme) => `${theme.palette.primary.main} 1px solid`,
    [catalogCompactMq]: {
        gap: "24px",
    },
    [catalogLayoutNarrowMq]: {
        flex: `0 0 ${CATALOG_CARDS_WIDTH_WIDE}`,
        width: CATALOG_CARDS_WIDTH_WIDE,
    },
    [catalogFilterToggleMq]: {
        flex: "0 0 100%",
        width: "100%",
        borderRight: "none",
    },
};

const catalogFilterSectionSx = {
    boxSizing: "border-box",
    flex: `0 0 ${CATALOG_FILTER_WIDTH}`,
    width: CATALOG_FILTER_WIDTH,
    flexShrink: 0,
    padding: "16px 16px 16px 16px",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    [catalogCompactMq]: {
        padding: "12px",
    },
    [catalogLayoutNarrowMq]: {
        flex: `0 0 ${CATALOG_FILTER_WIDTH_WIDE}`,
        width: CATALOG_FILTER_WIDTH_WIDE,
    },
    [catalogFilterToggleMq]: {
        flex: "0 0 100%",
        width: "100%",
        padding: "12px 0 0",
    },
};

const catalogFilterToggleButtonSx = {
    display: "none",
    [catalogFilterToggleMq]: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 40,
        minWidth: 40,
        height: 40,
        minHeight: 40,
        padding: 0,
        boxSizing: "border-box",
        borderRadius: "8px",
        border: "1px solid #EAEBEA",
        color: "#737478",
        backgroundColor: "transparent",
        cursor: "pointer",
    },
};

const catalogApplyFiltersButtonSx = {
    display: "none",
    [catalogFilterToggleMq]: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: 44,
        padding: "0 16px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: (theme) => theme.palette.primary.main,
        color: "white",
        fontSize: "16px",
        fontWeight: 700,
        lineHeight: 1,
        cursor: "pointer",
    },
};

const catalogCardWrapperSx = {
    width: CATALOG_CARD_WIDTH,
    containerType: "inline-size",
    flexShrink: 0,
    display: "flex",
    flexDirection: "column",
    alignSelf: "flex-start",
    position: "relative",
    overflow: "visible",
    "&:has(.catalog-card:hover)": {
        zIndex: 2,
    },
    [catalogCompactMq]: {
        width: CATALOG_CARD_WIDTH_COMPACT,
    },
    [catalogLayoutNarrowMq]: {
        width: CATALOG_CARD_WIDTH_WIDE_COMPACT,
    },
    [catalogFilterToggleMq]: {
        width: CATALOG_CARD_WIDTH_1023,
    },
    [catalogStackMq]: {
        width: "100%",
    },
};

const catalogFilterContentSx = {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "24px",
    [catalogCompactMq]: {
        gap: "16px",
    },
};

const catalogRangeRowSx = {
    display: "flex",
    columnGap: "8px",
    [catalogCompactMq]: {
        columnGap: "6px",
    },
};

const catalogRangeFieldSx = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    [catalogCompactMq]: {
        gap: "6px",
    },
};

const catalogFilterBlockTitleSx = {
    fontSize: "18px",
    fontWeight: 600,
};

const catalogFilterBlockSx = {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    [catalogCompactMq]: {
        gap: "12px",
    },
};

const catalogCheckboxListSx = {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    width: "100%",
    [catalogCompactMq]: {
        gap: "6px",
    },
};

const catalogListItemSx = {
    ...catalogTextSx,
    padding: "8px 16px",
    boxSizing: "border-box",
    borderBottom: "1px solid rgba(180, 184, 204, 0.36)",
    [catalogCompactMq]: {
        padding: "6px 12px",
    },
};

const catalogFormControlLabelSx = {
    marginLeft: 0,
    marginRight: 0,
    columnGap: "16px",
    [catalogCompactMq]: {
        columnGap: "12px",
    },
    width: "100%",
    maxWidth: "100%",
    ...catalogListItemSx,
    "& .MuiFormControlLabel-label": {
        marginLeft: 0,
        ...catalogTextSx,
    },
};

const catalogCheckboxProps = {
    icon: <Box className="catalog-checkbox-icon" sx={catalogCheckboxIconSx}/>,
    checkedIcon: (
        <Box className="catalog-checkbox-icon" sx={{
            ...catalogCheckboxIconSx,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: (theme) => theme.palette.primary.main,
            borderColor: (theme) => theme.palette.primary.main,
        }}>
            <CheckIcon sx={{
                width: 16,
                height: 16,
                color: "#fff",
                [catalogCompactMq]: {
                    width: 14,
                    height: 14,
                },
            }}/>
        </Box>
    ),
    sx: catalogCheckboxSx,
};

const filterFieldSx = {
    width: "100%",
    "& .MuiOutlinedInput-root": {
        borderRadius: "8px",
        height: 40,
        "& .MuiOutlinedInput-input": {
            padding: "0 8px 0 12px",
            ...catalogTextSx,
        },
        "& fieldset": {
            border: "1px solid #EAEBEA",
            borderRadius: "8px",
        },
        "&:hover fieldset": {
            border: "1px solid #EAEBEA",
        },
        "&.Mui-focused fieldset": {
            border: "1px solid #EAEBEA",
            borderWidth: "1px",
        },
    },
    [catalogCompactMq]: {
        "& .MuiOutlinedInput-root": {
            height: CATALOG_COMPACT_INPUT_HEIGHT,
        },
        "& .MuiOutlinedInput-root.MuiInputBase-adornedEnd": {
            paddingRight: "8px",
        },
        "& .MuiOutlinedInput-input": {
            padding: "0 6px 0 8px",
            fontSize: "14px",
        },
    },
};

const searchFieldSx = {
    ...filterFieldSx,
    "& .MuiOutlinedInput-root.MuiInputBase-adornedStart": {
        paddingLeft: "8px",
    },
    "& .MuiOutlinedInput-root.MuiInputBase-adornedEnd": {
        paddingRight: "8px",
    },
    "& .MuiInputAdornment-root": {
        margin: 0,
        maxHeight: "unset",
    },
    "& .MuiOutlinedInput-input": {
        padding: "0 8px",
        ...catalogTextSx,
    },
    [catalogCompactMq]: {
        "& .MuiOutlinedInput-root.MuiInputBase-adornedStart": {
            paddingLeft: "6px",
        },
        "& .MuiOutlinedInput-root.MuiInputBase-adornedEnd": {
            paddingRight: "6px",
        },
        "& .MuiOutlinedInput-input": {
            padding: "0 6px",
        },
    },
};

const priceTextSx = {
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: 1.4,
    color: "#737478",
};

const priceFieldSx = {
    ...filterFieldSx,
    "& .MuiOutlinedInput-root.MuiInputBase-adornedEnd": {
        paddingRight: "10px",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
        WebkitAppearance: "none",
        margin: 0,
    },
    "& .MuiOutlinedInput-input::placeholder": {
        ...priceTextSx,
        opacity: 1,
    },
    [catalogCompactMq]: {
        "& .MuiOutlinedInput-root.MuiInputBase-adornedEnd": {
            paddingRight: "8px",
        },
    },
};

const catalogMenuItemSx = {
    ...catalogTextSx,
    padding: "8px 16px",
    minHeight: "unset",
    [catalogCompactMq]: {
        padding: "6px 12px",
    },
    "&:hover": {
        backgroundColor: "rgba(180, 184, 204, 0.18)",
    },
    "&.Mui-selected": {
        ...catalogTextSx,
        backgroundColor: "rgba(180, 184, 204, 0.18)",
    },
    "&.Mui-selected:hover": {
        backgroundColor: "rgba(180, 184, 204, 0.18)",
    },
    "&.Mui-focusVisible": {
        backgroundColor: "rgba(180, 184, 204, 0.18)",
    },
};

const CatalogSelectIcon = (props) => (
    <KeyboardArrowDownIcon {...props} sx={catalogFilterIconSx}/>
);

const catalogSelectMenuProps = {
    PaperProps: {
        sx: {
            maxWidth: "100%",
        },
    },
};

const priceLabelSx = catalogTextSx;

const normalizeNumericValue = (value) => value.replace(/\s/g, "");

const RANGE_BLOCKS = [
    {
        title: "Цена",
        fromField: "priceFrom",
        toField: "priceTo",
        fromLabel: "От, р",
        toLabel: "До, р",
        fromPlaceholder: "1 000",
        toPlaceholder: "12 000",
    },
    {
        title: "Левая сторона",
        fromField: "sizeLeftFrom",
        toField: "sizeLeftTo",
        fromLabel: "От, мм",
        toLabel: "До, мм",
        fromPlaceholder: "800",
        toPlaceholder: "3 000",
    },
    {
        title: "Правая сторона",
        fromField: "sizeRightFrom",
        toField: "sizeRightTo",
        fromLabel: "От, мм",
        toLabel: "До, мм",
        fromPlaceholder: "800",
        toPlaceholder: "3 000",
    },
];

const SORT_OPTIONS = [
    {value: "", label: "По умолчанию"},
    {value: "PRICE_ASC", label: "Цена: по возрастанию"},
    {value: "PRICE_DESC", label: "Цена: по убыванию"},
    {value: "NAME_ASC", label: "Название: А-Я"},
    {value: "NAME_DESC", label: "Название: Я-А"},
    {value: "LEFT_ASC", label: "Расстояние слева: по возрастанию"},
    {value: "LEFT_DESC", label: "Расстояние слева: по убыванию"},
    {value: "RIGHT_ASC", label: "Расстояние справа: по возрастанию"},
    {value: "RIGHT_DESC", label: "Расстояние справа: по убыванию"},
];

const getSortLabel = (value) => SORT_OPTIONS.find((option) => option.value === value)?.label ?? "По умолчанию";

const catalogSelectProps = {
    MenuProps: catalogSelectMenuProps,
    IconComponent: CatalogSelectIcon,
    displayEmpty: true,
    renderValue: getSortLabel,
};

const buildCatalogUrl = (straight, corner, popular, discountProducts) => {
    const params = new URLSearchParams();

    if (corner && !straight) {
        params.set('type', 'CORNER');
    } else if (straight && !corner) {
        params.set('type', 'STRAIGHT');
    }

    if (popular) {
        params.set('top', 'true');
    }
    if (discountProducts) {
        params.set('discount', 'true');
    }

    const queryString = params.toString();
    return queryString ? `/catalog?${queryString}` : '/catalog';
};

const Catalog = () => {
    const isKuhniVersoMebel = isKuhniVersoMebelDomain();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const type = searchParams.get('type') || "ALL";
    const topFilter = searchParams.get('top') === 'true';
    const discountFilter = searchParams.get('discount') === 'true';
    const modelFilter = searchParams.get('model') || "";
    const navigate = useNavigate();
    const isFilterToggleViewport = useMediaQuery(`(max-width:${CATALOG_FILTER_TOGGLE_BREAKPOINT}px)`);
    const [formState, setFormState] = useState({straight: true, corner: true});
    const [specialFormState, setSpecialFormState] = useState({popular: false, discountProducts: false});
    const [isFiltersOpen, setIsFiltersOpen] = useState(false);
    const [data, setData] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 6,
        totalElements: 0,
        searchData: "",
        sort: "",
        priceFrom: "",
        priceTo: "",
        sizeLeftFrom: "",
        sizeLeftTo: "",
        sizeRightFrom: "",
        sizeRightTo: "",
    })
    const rangeRefs = useRef({
        priceFrom: "",
        priceTo: "",
        sizeLeftFrom: "",
        sizeLeftTo: "",
        sizeRightFrom: "",
        sizeRightTo: "",
    });

    const buildFilters = (options) => ({
        search: options.searchData || undefined,
        model: modelFilter || undefined,
        top: topFilter,
        discount: discountFilter,
        sort: options.sort || undefined,
        priceFrom: normalizeNumericValue(options.priceFrom),
        priceTo: normalizeNumericValue(options.priceTo),
        sizeLeftFrom: normalizeNumericValue(options.sizeLeftFrom),
        sizeLeftTo: normalizeNumericValue(options.sizeLeftTo),
        sizeRightFrom: normalizeNumericValue(options.sizeRightFrom),
        sizeRightTo: normalizeNumericValue(options.sizeRightTo),
    });

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const getData = (isUpdate, cornerType, pageSize, pageIndex, options) => {
        CustomerCompositionController.get("KITCHEN", cornerType, pageSize, pageIndex, buildFilters(options)).then(function (response) {
            isUpdate ? setData(response.data.content) : setData([...data, ...response.data.content])

            setTableOptions((prev) => ({...prev, totalElements: response.data.totalElements}))
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }
    useEffect(() => {
        if (type === "ALL") {
            setFormState({straight: true, corner: true})
        } else if (type === "STRAIGHT") {
            setFormState({straight: true, corner: false})
        } else {
            setFormState({straight: false, corner: true})
        }

        setSpecialFormState({popular: topFilter, discountProducts: discountFilter})

        setTableOptions((prev) => ({...prev, pageIndex: 0}))
        getData(true, type, tableOptions.pageSize, 0, tableOptions)
    }, [location.search])

    const fetchCatalog = (isUpdate, pageIndex, optionsOverride = {}) => {
        const options = {...tableOptions, pageIndex, ...optionsOverride};
        getData(isUpdate, type, options.pageSize, pageIndex, options);
    }

    const handleSearchChange = (event) => {
        const searchData = event.target.value;
        const options = {...tableOptions, searchData, pageIndex: 0};
        setTableOptions(options);
        if (!isFilterToggleViewport) {
            fetchCatalog(true, 0, options);
        }
    }

    const handleSearchClear = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const options = {...tableOptions, searchData: "", pageIndex: 0};
        setTableOptions(options);
        if (!isFilterToggleViewport) {
            fetchCatalog(true, 0, options);
        }
    }

    const handleSortChange = (event) => {
        const sort = event.target.value;
        const options = {...tableOptions, sort, pageIndex: 0};
        setTableOptions(options);
        if (!isFilterToggleViewport) {
            fetchCatalog(true, 0, options);
        }
    }

    const handleRangeChange = (field) => (event) => {
        const value = event.target.value;
        rangeRefs.current[field] = value;
        setTableOptions((prev) => ({...prev, [field]: value}));
    }

    const handleRangeBlur = (fromField, toField) => () => {
        const from = normalizeNumericValue(rangeRefs.current[fromField]);
        const to = normalizeNumericValue(rangeRefs.current[toField]);
        rangeRefs.current[fromField] = from;
        rangeRefs.current[toField] = to;
        const options = {...tableOptions, [fromField]: from, [toField]: to, pageIndex: 0};
        setTableOptions(options);
        if (!isFilterToggleViewport) {
            fetchCatalog(true, 0, options);
        }
    }

    const handleRangeClear = (field) => (event) => {
        event.preventDefault();
        event.stopPropagation();

        rangeRefs.current[field] = "";
        const options = {
            ...tableOptions,
            [field]: "",
            pageIndex: 0,
        };
        setTableOptions(options);
        if (!isFilterToggleViewport) {
            fetchCatalog(true, 0, options);
        }
    }

    const renderRangeClearButton = (field, value) => value ? (
        <InputAdornment position="end">
            <IconButton
                onMouseDown={(event) => event.preventDefault()}
                onClick={handleRangeClear(field)}
                sx={{
                    ...catalogFilterIconButtonSx,
                    color: "#737478",
                }}
            >
                <CloseIcon sx={catalogFilterIconSx}/>
            </IconButton>
        </InputAdornment>
    ) : null;

    const renderRangeBlock = ({title, fromField, toField, fromLabel, toLabel, fromPlaceholder, toPlaceholder}) => (
        <Box sx={catalogFilterBlockSx}>
            <Typography sx={catalogFilterBlockTitleSx}>
                {title}
            </Typography>
            <Box sx={catalogRangeRowSx}>
                <Box sx={catalogRangeFieldSx}>
                    <Typography sx={priceLabelSx}>
                        {fromLabel}
                    </Typography>
                    <TextField
                        placeholder={fromPlaceholder}
                        type="number"
                        value={tableOptions[fromField]}
                        onChange={handleRangeChange(fromField)}
                        onBlur={handleRangeBlur(fromField, toField)}
                        inputProps={{min: 0}}
                        InputProps={{
                            endAdornment: renderRangeClearButton(fromField, tableOptions[fromField]),
                        }}
                        sx={priceFieldSx}
                    />
                </Box>
                <Box sx={catalogRangeFieldSx}>
                    <Typography sx={priceLabelSx}>
                        {toLabel}
                    </Typography>
                    <TextField
                        placeholder={toPlaceholder}
                        type="number"
                        value={tableOptions[toField]}
                        onChange={handleRangeChange(toField)}
                        onBlur={handleRangeBlur(fromField, toField)}
                        inputProps={{min: 0}}
                        InputProps={{
                            endAdornment: renderRangeClearButton(toField, tableOptions[toField]),
                        }}
                        sx={priceFieldSx}
                    />
                </Box>
            </Box>
        </Box>
    );

    const handleType = (field, value) => {
        const newData = {
            ...formState,
            [field]: value
        }
        if (isFilterToggleViewport) {
            setFormState(newData);
            return;
        }
        navigate(buildCatalogUrl(
            newData.straight,
            newData.corner,
            specialFormState.popular,
            specialFormState.discountProducts
        ))
    }

    const handleSpecialOffer = (field, value) => {
        const newData = {
            ...specialFormState,
            [field]: value
        }
        if (isFilterToggleViewport) {
            setSpecialFormState(newData);
            return;
        }
        navigate(buildCatalogUrl(
            formState.straight,
            formState.corner,
            newData.popular,
            newData.discountProducts
        ))
    }

    const handleMore = () => {
        const pageIndex = tableOptions.pageIndex + 1
        setTableOptions((prev) => ({
            ...prev,
            pageIndex: pageIndex
        }))
        fetchCatalog(false, pageIndex, {...tableOptions, pageIndex})
    }

    const handleApplyFilters = () => {
        const nextUrl = buildCatalogUrl(
            formState.straight,
            formState.corner,
            specialFormState.popular,
            specialFormState.discountProducts
        );
        const currentUrl = `${location.pathname}${location.search}`;
        const options = {...tableOptions, pageIndex: 0};
        setTableOptions(options);

        if (currentUrl !== nextUrl) {
            navigate(nextUrl);
        } else {
            fetchCatalog(true, 0, options);
        }

        setIsFiltersOpen(false);
    };

    const showFiltersOnly = isFilterToggleViewport && isFiltersOpen;
    const shouldRenderFilters = !isFilterToggleViewport || isFiltersOpen;
    const shouldRenderCards = !showFiltersOnly;

    return (
        <>
            <Paper sx={{
                width: '100%',
                paddingBottom: "40px",
                display: 'flex',
                justifyContent: "space-between",
                flexGrow: 1
            }}>
                <Container sx={{
                    "&.MuiContainer-root": {
                        maxWidth: "1668px",
                        display: 'flex',
                        flexDirection: "column",
                        gridGap: "100px",
                        ...(isKuhniVersoMebel ? kuhniVersoTabletContainerQuerySx : {}),
                    },
                }}>
                    <Box>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: "12px",
                                width: "100%",
                            }}
                        >
                            <BreadcrumbsComponent
                                page={"Каталог"}
                                path={[
                                    {name: "Главная", href: "/"},
                                ]}/>
                            <IconButton
                                aria-label={isFiltersOpen ? "Скрыть фильтры" : "Показать фильтры"}
                                onClick={() => setIsFiltersOpen((prev) => !prev)}
                                sx={catalogFilterToggleButtonSx}
                            >
                                <Box
                                    component="img"
                                    src={catalogFilterToggleIcon}
                                    alt=""
                                    aria-hidden
                                    sx={{width: 16, height: 16, display: "block"}}
                                />
                            </IconButton>
                        </Box>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "row",
                            position: "relative",
                            width: "100%",
                            minWidth: 0,
                            gap: "16px",
                            [catalogFilterToggleMq]: {
                                flexDirection: "column",
                            },
                        }}>
                            {shouldRenderCards && (
                                <Box sx={catalogCardsSectionSx}>
                                    <Box sx={catalogCardsGridSx}>

                                        {data.map(item => {
                                            return (
                                                <Box key={item.id} sx={catalogCardWrapperSx}>
                                                    <Box aria-hidden sx={catalogCardFlowSizerSx}/>
                                                    <CardByCarousel
                                                        item={item}
                                                        catalogCard
                                                        width={"100%"}
                                                        widthImg={"100%"}
                                                        compactBelow1440
                                                        onClick={() => navigate(`/catalog/${item.id}`)}/>
                                                </Box>
                                            );
                                        })}

                                    </Box>
                                    {tableOptions.totalElements > data.length && (
                                        <Box sx={catalogShowMoreButtonWrapperSx}>
                                            <ButtonSelectAction
                                                text="Показать ещё"
                                                onClick={handleMore}
                                                showIcon={false}
                                            />
                                        </Box>
                                    )}
                                </Box>
                            )}
                            {shouldRenderFilters && (
                                <Box sx={catalogFilterSectionSx}>
                                    <Box sx={catalogFilterContentSx}>
                                        <TextField
                                            placeholder="Поиск"
                                            value={tableOptions.searchData}
                                            onChange={handleSearchChange}
                                            InputProps={{
                                                startAdornment: (
                                                    <InputAdornment position="start" sx={{margin: 0}}>
                                                        <SearchIcon sx={catalogFilterIconSx}/>
                                                    </InputAdornment>
                                                ),
                                                endAdornment: (
                                                    <InputAdornment position="end" sx={{margin: 0}}>
                                                        <IconButton
                                                            disabled={!tableOptions.searchData}
                                                            onMouseDown={(event) => event.preventDefault()}
                                                            onClick={handleSearchClear}
                                                            sx={{
                                                                ...catalogFilterIconButtonSx,
                                                                color: "#737478",
                                                                "&.Mui-disabled": {
                                                                    opacity: 1,
                                                                },
                                                                "&.Mui-disabled .MuiSvgIcon-root": {
                                                                    color: "rgba(0, 0, 0, 0.42)",
                                                                },
                                                            }}
                                                        >
                                                            <CloseIcon sx={{
                                                                ...catalogFilterIconSx,
                                                                color: "inherit",
                                                            }}/>
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                            sx={{
                                                paddingTop: "5px",
                                                ...searchFieldSx,
                                                [catalogCompactMq]: {
                                                    paddingTop: "4px",
                                                },
                                            }}
                                        />
                                        <Box sx={catalogFilterBlockSx}>
                                            <Typography sx={catalogFilterBlockTitleSx}>
                                                Сортировка
                                            </Typography>
                                            <TextField
                                                select
                                                value={tableOptions.sort}
                                                onChange={handleSortChange}
                                                SelectProps={catalogSelectProps}
                                                sx={filterFieldSx}
                                            >
                                                {SORT_OPTIONS.map((option) => (
                                                    <MenuItem key={option.value || "default"} value={option.value} sx={catalogMenuItemSx}>
                                                        {option.label}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        </Box>
                                        {renderRangeBlock(RANGE_BLOCKS[0])}
                                        <Box sx={catalogFilterBlockSx}>
                                            <Typography sx={catalogFilterBlockTitleSx}>
                                                Тип
                                            </Typography>
                                            <Box sx={catalogCheckboxListSx}>
                                                <FormControlLabel
                                                    sx={catalogFormControlLabelSx}
                                                    control={<Checkbox
                                                        {...catalogCheckboxProps}
                                                        checked={formState?.straight}
                                                        onChange={() => handleType("straight", !formState.straight)}
                                                    />} label="Прямая"/>
                                                <FormControlLabel
                                                    sx={catalogFormControlLabelSx}
                                                    control={<Checkbox
                                                        {...catalogCheckboxProps}
                                                        checked={formState?.corner}
                                                        onChange={() => handleType("corner", !formState.corner)}
                                                    />} label="Угловая"/>
                                            </Box>
                                        </Box>
                                        {renderRangeBlock(RANGE_BLOCKS[1])}
                                        {renderRangeBlock(RANGE_BLOCKS[2])}
                                        <Box sx={catalogFilterBlockSx}>
                                            <Typography sx={catalogFilterBlockTitleSx}>
                                                Спецпредложения
                                            </Typography>
                                            <Box sx={catalogCheckboxListSx}>
                                                <FormControlLabel
                                                    sx={catalogFormControlLabelSx}
                                                    control={<Checkbox
                                                        {...catalogCheckboxProps}
                                                        checked={specialFormState?.popular}
                                                        onChange={() => handleSpecialOffer("popular", !specialFormState.popular)}
                                                    />} label="Популярное"/>
                                                <FormControlLabel
                                                    sx={catalogFormControlLabelSx}
                                                    control={<Checkbox
                                                        {...catalogCheckboxProps}
                                                        checked={specialFormState?.discountProducts}
                                                        onChange={() => handleSpecialOffer("discountProducts", !specialFormState.discountProducts)}
                                                    />} label="Товары со скидкой"/>
                                            </Box>
                                        </Box>
                                        <Box
                                            component="button"
                                            type="button"
                                            onClick={handleApplyFilters}
                                            sx={catalogApplyFiltersButtonSx}
                                        >
                                            Применить фильтры
                                        </Box>
                                    </Box>
                                </Box>
                            )}
                        </Box>

                    </Box>
                </Container>
            </Paper>
            {!(isFilterToggleViewport && isFiltersOpen) && <Footer></Footer>}
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false}
            })}/>
        </>
    );
};

export default Catalog;